import { getFromLocalStorage } from 'src/functions/function-local-storage'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/database'
import 'firebase/compat/firestore'
import 'firebase/compat/analytics'
import 'firebase/compat/storage'
import 'firebase/compat/functions'

const firebaseConfig = {
  apiKey: 'AIzaSyBfANCHuI3NUofdGnM2nXcDtFeiDxndPAg',
  authDomain: 'englishclinic-eb986.firebaseapp.com',
  databaseURL: 'https://englishclinic-eb986-default-rtdb.firebaseio.com',
  projectId: 'englishclinic-eb986',
  storageBucket: 'englishclinic-eb986.appspot.com',
  messagingSenderId: '845285570692',
  appId: '1:845285570692:web:b5f92a2d13fa7ec8fd6ad1',
  measurementId: 'G-H5NF18N1SH',
}

let firebaseApp = firebase.initializeApp(firebaseConfig)
let fbAuth = firebaseApp.auth()
let fbDatabase = firebaseApp.database()
let fbFirestore = firebaseApp.firestore()
// The web Analytics SDK is not meant for the Android WebView
let fbAnalytics = import.meta.env.QUASAR_CAPACITOR_MODE ? null : firebaseApp.analytics()
let fbStorage = firebaseApp.storage()
let fbFunctions = firebaseApp.functions()
let fbTimestamp = firebase.database.ServerValue.TIMESTAMP

/* all this trouble because I can't send notifications without being a registered Apple dev and pay 99 a year */
/* TODO: terminar o service worker, adicionar o arquivo... ect... */
/* let fbMessaging = false

if (Platform.is.iphone){
  console.error('FCM not supported');
} else {
  fbMessaging = firebaseApp.messaging()
  navigator.serviceWorker.register('firebase-messaging-sw.js', {scope: "firebase-cloud-messaging-push-scope"})
    .then((registration) => {
        //const messaging = firebase.messaging();
        fbMessaging.useServiceWorker(registration);

    }).catch(err => {
    })
} */

// the Android app is also served from https://localhost — emulators are for web dev only
if (window.location.hostname === 'localhost' && !import.meta.env.QUASAR_CAPACITOR_MODE) {
  let emulatorFunctions = getFromLocalStorage('prefs/functions_emulator')
  let emulatorRtdb = getFromLocalStorage('prefs/rtdb_emulator')
  if (emulatorFunctions) {
    fbFunctions.useEmulator('localhost', 5001)
    console.warn('emulatorFunctions ON')
  }

  if (emulatorRtdb) {
    fbDatabase.useEmulator('localhost', 9098)
    console.warn('emulatorRtdb ON')
  }
}

export {
  firebase,
  fbTimestamp,
  fbAuth,
  fbFunctions,
  fbDatabase,
  /* fbMessaging , */ fbFirestore,
  fbAnalytics,
  fbStorage,
}
